import React from "react";

const FooterItem = ({ item, itemClasses }) => (
  <div className={`footer-item ${itemClasses}`}>
    <item.component {...item.props} />
  </div>
);

export default FooterItem;
